/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useParams } from "react-router-dom";

async function clientDelete(token, id) {
  return fetch(process.env.REACT_APP_API_URL + '/crud/clients/' + id,
    {
      method: 'DELETE',
      headers: {
        'Authorization': 'Bearer '+ token,
        'Content-Type': 'application/json'
      },
    })
    .then(data => data.json())
    .catch(function(error) {
      return error;
  });
}

export default function ClientDelete(props) {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const { id } = useParams();

  const handleSubmit = async e => {
    e.preventDefault();
    const response = await clientDelete(props.token, id);
    if (!response || response.error) {
        setError(true)
        return
    }
    setError(false);
    setSuccess(true);
    console.log(response);
  }

  return(
    <div>
      {error ?
        <div className="uk-alert-danger" uk-alert="">
            <p>Client delete error!</p>
        </div>
      : null}
      {success ?
        <div className="uk-alert-success" uk-alert="">
            <a className="uk-alert-close" uk-close=""></a>
            <p>Client deleted successfully</p>
            <a href={'../../'}>
              <button className="uk-button uk-button-default"><span uk-icon="arrow-left"></span> OMS</button>
            </a>
        </div>
      : <div>
          <a href={'../' + id + '/'}>
            <button className="uk-button uk-button-default"><span uk-icon="arrow-left"></span> client</button>
          </a>
          <div className="uk-card uk-card-default uk-margin-top">
            <div className="uk-card-header">
                <h3 className="uk-card-title">Delete Client</h3>
            </div>
            <div className="uk-card-body">
            <form className="uk-form-horizontal" uk-grid="" onSubmit={handleSubmit}>
              <p>Are you sure you want to <span className="uk-alert-danger">DELETE</span> the <a href={'../' + id + '/'}>client</a>?</p>
              <div className="uk-width-1-1@s uk-width-1-1@m">
                <button className="uk-button uk-button-default" type="submit">Delete</button>
              </div>
            </form>
            </div>
          </div>
        </div>
      }
    </div>
  );
}
